import { useMutation } from '@tanstack/react-query'
import { pasteToDesk, PasteToDeskParams, retryPaste } from 'supabase/desk/pasteToDesk'
import { queryClient } from 'utils'
import { isDeskTranslationQuery } from './useDeskTranslation'

// A paste can add a raw item and, after the editor, candidates to any tab:
// refresh the whole desk (queue, counts, candidate reads, the paste poll).
// The translation cache is skipped, so a paste never re-spends DeepL quota
// (spec-desk-auto-translate D-05).
const invalidate = () => {
  queryClient.invalidateQueries({ queryKey: ['desk'], predicate: (query) => !isDeskTranslationQuery(query) })
}

/**
 * Send a paste, or retry a saved one, to desk-paste with the admin's own
 * session (D-17). Both resolve to a DeskPasteOutcome and never throw for a
 * refusal: the code drives the paste panel (UI-SPEC §G).
 */
export const usePasteToDesk = () => {
  const send = useMutation({
    mutationFn: (params: PasteToDeskParams) => pasteToDesk(params),
    onSettled: invalidate
  })

  const retry = useMutation({
    mutationFn: (rawItemId: number) => retryPaste(rawItemId),
    onSettled: invalidate
  })

  return { send, retry }
}
